import { Record } from 'immutable';
class OutOfTheOfficeStatusRecord extends Record({
  outOfTheOffice: false,
  untilMillis: undefined,
  hubspotterId: undefined,
  summary: undefined,
  loading: false
}, 'OutOfTheOfficeStatusRecord') {}
export default OutOfTheOfficeStatusRecord;